import { create } from 'zustand'
import type { UserProfile } from '../types/api'

export type AuthStatus = 'boot' | 'authenticated' | 'unauthenticated'

interface AuthState {
    status: AuthStatus
    accessToken: string | null
    user: UserProfile | null
    setSession: (accessToken: string, user: UserProfile) => void
    setUser: (user: UserProfile) => void
    clear: () => void
}

// Access-Token bewusst nur im Speicher — Erneuerung läuft über den
// httpOnly-Refresh-Cookie, nicht über localStorage.
export const useAuthStore = create<AuthState>()(set => ({
    status: 'boot',
    accessToken: null,
    user: null,
    setSession: (accessToken, user) =>
        set({ status: 'authenticated', accessToken, user }),
    setUser: user => set({ user }),
    clear: () =>
        set({ status: 'unauthenticated', accessToken: null, user: null }),
}))
